import type React from 'react'

import { MarkerF, type MarkerProps } from '@react-google-maps/api'

import { svgPinMarker } from '@/components/atoms/MapSvgMarker/svgRequestMarker.ts'

import { markerLabel } from './markerLabel.ts'

export type PinRequestMarkerProps = {
  label: string
  type: 'assigned' | 'allocated' | 'onboarded'
  children?: React.ReactNode
} & Omit<MarkerProps, 'icon' | 'label'>

export const PinRequestMarker: React.FC<PinRequestMarkerProps> = ({ label, type, children, ...props }) => (
  <MarkerF
    {...props}
    label={markerLabel(label, type)}
    icon={{
      url: `data:image/svg+xml;utf-8,${encodeURIComponent(svgPinMarker(type))}`,
      scaledSize: new google.maps.Size(36, 40),
      labelOrigin: new google.maps.Point(18, 14),
      // Adjustments because of the shadow
      anchor: new google.maps.Point(18, 33),
    }}>
    {children}
  </MarkerF>
)
